import { render, staticRenderFns } from "./PostTermSaleNotice.vue?vue&type=template&id=547c2c3e&scoped=true"
import script from "./PostTermSaleNotice.vue?vue&type=script&lang=js"
export * from "./PostTermSaleNotice.vue?vue&type=script&lang=js"
import style0 from "./PostTermSaleNotice.vue?vue&type=style&index=0&id=547c2c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c2c3e",
  null
  
)

export default component.exports